import { PrintOrientations } from '@i-ark/models';

const printOrientationMap = new Map();
function selectPrintOrientation(state) {
  let printOrientation = printOrientationMap.get(state.component.envelope.ID);
  if (printOrientation === undefined) {
    let landscapePages = 0;
    let portraitPages = 0;
    state.component.data.pages.forEach(page => {
      if (page.aspectRatio <= 1) {
        landscapePages++;
      } else {
        portraitPages++;
      }
    });
    printOrientation = landscapePages >= portraitPages ? PrintOrientations.LANDSCAPE : PrintOrientations.PORTRAIT;
    printOrientationMap.set(state.component.envelope.ID, printOrientation);
  }
  return printOrientation;
}

export { selectPrintOrientation };
//# sourceMappingURL=print.get-orientation.js.map
